import './skip-link-focus-fix';
import "script-loader!smartmenus";
// import AOS from 'aos';
import Rellax from 'rellax';
import Cookies from 'js-cookie';
import "smartmenus/dist/css/sm-core-css.css";
import "smartmenus/dist/css/sm-simple/sm-simple.scss";
import 'script-loader!slick-carousel';
import 'script-loader!lity';
import 'script-loader!jquery.marquee';

(function($) {
	// AOS.init({ once: true, duration: 500, disable: true });
	var rellax = new Rellax('.rellax');

	// scroll to anchor id with header offset
	// $("a[href*='#']:not(.dropdown-toggle)").on('click',function(e) {
	// 	e.preventDefault();
	// 	var offset = $('#masthead').outerHeight();
	// 	var target = this.hash;
	// 	if ($(this).data('offset') != undefined) offset = $(this).data('offset');
	// 	$('html, body').stop().animate({
	// 		'scrollTop': $(target).offset().top - offset
	// 	}, 500, 'swing', function() {
	// 		// window.location.hash = target;
	// 	});
	// });

	$(document).ready(function() {
		menuToggle();
		miniFaqsBlock();
		accordionShortcode();
		statisticsBlock();
		// siteHeaderDropdown();
		
		$(window).on('scroll', function(){
			headerEffects();
		});

		$(window).trigger('scroll');

		$('.marquee').marquee({ startVisible: true });

		$('.portfolio-text__left-pillar').marquee({
			duration: 100000,
			gap: 0,
			duplicated: true,
			startVisible: true,
			pauseOnHover: true,
			direction: 'down'
		})

		$('.portfolio-text__right-pillar').marquee({
			duration: 100000,
			gap: 0,
			duplicated: true,
			startVisible: true,
			pauseOnHover: true,
			direction: 'up'
		})

		// Idk if this is the best way to handle it, but for now this is how we track visited pages for the checklist element.
		// Updated 6/8/23
		// var pageIdClass = ($('body')[0].className.match(/(^|\s)(page\-id\-[^\s]*)/) || [,,''])[2],
		const checklist = document.querySelector('.page-header__checklist-list');

		if( checklist ){
			const currentHref = window.location.href;

			var pagesCookie = Cookies.get('pages-visited'),
				pagesArray  = [];

			if( pagesCookie ) {
				pagesArray = JSON.parse(pagesCookie);
			}
				
			// if(pageIdClass && !pagesArray.includes(pageId) ) {
			// 	var pageId = pageIdClass.match(/\d+/)[0];
			    
			// 	pagesArray.push(pageId);
			// }

			if (currentHref && !pagesArray.includes(currentHref)) {
				pagesArray.push(currentHref);
			}

			Cookies.set('pages-visited', JSON.stringify(pagesArray), { expires: 7 });
		}

		if(checklist) {
			var allChecked = 1;

			const allChecklistItems = checklist.querySelectorAll('li');

			allChecklistItems.forEach(item => {
				let thisHref = item.querySelector('a').href;

				if (pagesArray.includes(thisHref)) {
					item.classList.add('checked');
				} else {
					allChecked = 0;
				}
			})

			// $(checklist).children().each(function(){
			// 	var pageId = $(this).data('page-id').toString();

			// 	if($.inArray( pageId, pagesArray ) > -1) {
			// 		$(this).addClass('checked');
			// 	} else {
			// 		allChecked = 0;
			// 	}
			// });

			if(allChecked === 1) {
				var check = $('#checklist-check');

				check.addClass('page-header__checklist-check--checked');
			}
		}
	});

	  // smartmenus primary menu
	  $(function () {
		$("ul.primary-menu").smartmenus({
		  subMenusSubOffsetX: 1,
		  subMenusSubOffsetY: -1,
		});
	  });

	// Header scroll effects
	function headerEffects() {
		var header         = $('#masthead'),
			scrollPosition = $(window).scrollTop();

		if(scrollPosition > 1)
			header.addClass('site-header--scrolled');
		else
			header.removeClass('site-header--scrolled');
	}	

	// Header menu toggle
	function menuToggle() {
		$("#menu-toggle").on('click', function() {
			$(this).toggleClass('site-header__menu-toggle--open');
			$(".primary-nav").slideToggle('fast');
		});

		$(".submenu-toggle").on('click', function() {
			var submenu = $(this).next('.sub-menu');
			$(this).toggleClass('submenu-toggle--open');
			submenu.slideToggle();
		});
	}

	// Search Toggle
	$('.primary-nav-search-icon').on('click', function() {
		$(this).siblings('.primary-nav-search').slideToggle('fast');
	})

	// Mini FAQs block
	function miniFaqsBlock() {
		$(".mini-faqs__faq-title").on('click', function(e) {
			e.preventDefault();

			var faq     = $(this).closest('.mini-faqs__faq'),
				content = faq.find('.mini-faqs__faq-content');
				
			content.slideToggle(300);
			faq.toggleClass('mini-faqs__faq--open');

			$('.mini-faqs__faq-content').not(content).slideUp(300);
			$('.mini-faqs__faq').not(faq).removeClass('mini-faqs__faq--open');
		});
	}

	// Accordion shortcode
	function accordionShortcode() {
		$('.accordion-shortcode__toggle').on('click', function () {
			var accordion = $(this).parent('.accordion-shortcode__toggle--container').parent('.accordion-shortcode'),
				content = $(this).parent('.accordion-shortcode__toggle--container').prev('.accordion-shortcode__content');

			content.slideToggle();
			$(this).toggleClass('accordion-shortcode__toggle--open');
		});
	}

	// Statistics block
	function statisticsBlock() {
		$('.statistics-block__stat-selector').on('click', function () {
			var container    = $('.statistics-block__stats-container'),
			    statistic    = $(this).data('stat'),
			    statContents = $('.statistics-block__content-wrap'),
			    statContent  = statContents.filter('[data-stat="' + statistic + '"]'),
			    statsOverlay = $('.statistics-block__stats-overlay');

			statContents.slideUp();
			statContent.slideDown();
			statsOverlay.slideUp();
			container.addClass('statistics-block__stats-container--open');
		});

		$('.statistics-block__close').on('click', function () {
			var container    = $('.statistics-block__stats-container'),
			    statContents = $('.statistics-block__content-wrap'),
			    statsOverlay = $('.statistics-block__stats-overlay');

			statContents.slideUp();
			statsOverlay.slideDown();
			container.removeClass('statistics-block__stats-container--open');
		});
	}

	// Site header dropdowns
	// function siteHeaderDropdown() {
	// 	$('.menu-item-has-children').each(function() {
	// 		var link     = $(this).find('.dropdown-toggle'),
	// 			dropdown = $(this).find('.header-dropdown'),
	// 			close    = $(this).find('.header-dropdown__close');

	// 		link.on('click', function(event) {
	// 			event.preventDefault();
	// 			dropdown.addClass('header-dropdown--open');
	// 		});

	// 		close.on('click', function(event) {
	// 			dropdown.removeClass('header-dropdown--open');
	// 		});
	// 	});
	// }

	// Home Hero Arrows hover
	setTimeout(() => {
		const homeHeroArrows = document.querySelector('.home-hero__popout-arrows');
		const homeHeroPopout = document.querySelector('.home-hero__popout');
	
		if (homeHeroArrows) {
			homeHeroArrows.addEventListener('mouseenter', () => {
				homeHeroPopout.classList.add('home-hero-popout-active');
			})
		}
	
		if (homeHeroPopout) {
			homeHeroPopout.addEventListener('mouseleave', () => {
				homeHeroPopout.classList.remove('home-hero-popout-active');
			})
		}
	}, 10)

	// Site Search Term
	const siteSearch = document.querySelector('.site-search-container');

	if (siteSearch) {
		document.addEventListener('facetwp-loaded', () => {
			const loadMoreButton = siteSearch.querySelector('.facetwp-load-more');
			const facetSearch = siteSearch.querySelector('.facetwp-search');
			const termDisplay = siteSearch.querySelector('.search-term');

			loadMoreButton.classList.add('btn', 'forefrontweb-button');
			
			if (facetSearch.value) {
				termDisplay.textContent = `Results for ${facetSearch.value}`;
			} else {
				termDisplay.textContent = "Can't find what you're looking for? We can help!";
			}

			facetSearch.addEventListener('change', (e) => {

				if (e.target.value) {
					termDisplay.textContent = `Results for ${e.target.value}`;
				} else {
					termDisplay.textContent = "Can't find what you're looking for? We can help!";
				}
			})
		})
	}

	// Computer screenshot parallax
	const parallax = document.querySelector('.parallax-image');

	const doParallax = () => {
		$('.parallax-image').each(function() {
			var windowHeight   = $(window).height(),
				scrollPosition = $(window).scrollTop(),
				imageHeight    = $(this).height(),
				imageBottom    = $(this).parent().offset().top + imageHeight,
				bottomOffset   = Math.max(windowHeight - imageBottom, 0),
				scrollPercent  = Math.min(Math.max(100 - 100*(imageBottom - scrollPosition + bottomOffset) / windowHeight, 0), 100);

			$(this).css('background-position-y', scrollPercent + '%');
		});
	}

	if (parallax) {
		window.addEventListener('scroll', doParallax);
		window.addEventListener('resize', doParallax);
	}

	// Blog Author Box stays fixed on scroll
	const authorBox = document.querySelector('.single-post__author-box');
	
	if (authorBox) {
		window.addEventListener('scroll', (e) => {
			const screenWidth = window.innerWidth;

			if (screenWidth > 1300) {
				const docHeight = document.body.scrollHeight;
				const scrollPosition = window.scrollY;
				const blogContainer = document.querySelector('.single-wrap');
				const containerHeight = blogContainer.offsetHeight;
				const scrollAllowance = docHeight - 1160;

				if (scrollAllowance > scrollPosition) {
					if (scrollPosition > 225) {
						authorBox.style.top = `${108 + (scrollPosition - 225)}px`
						authorBox.style.bottom = "unset";

					} else {
						authorBox.style.top = "108px";
					}
				} else {
					authorBox.style.top = `unset`;
					authorBox.style.bottom = '100px';
				}
			}
		})
	}

	// Desktop Submenu has tertiary menu
	setTimeout(() => {
		const subArrow = document.querySelectorAll('.primary-menu > .menu-item-has-children > .sub-menu > .menu-item-has-children > .has-submenu > .sub-arrow');
	
		const toggleSubMenuClass = (e, arrow) => {
			e.stopPropagation();
			e.preventDefault();
			const nearestParent = arrow.closest('.menu-item-has-children');
	
			if (nearestParent.classList.contains('show-submenu')) {
				nearestParent.classList.remove('show-submenu');
			} else {
				nearestParent.classList.add('show-submenu');
			}
		}
	
		if (subArrow.length > 0 && window.innerWidth > 1080) {
			subArrow.forEach(arrow => {
				arrow.addEventListener("click", (e) => toggleSubMenuClass(e, arrow));
			})
		}
	}, 750)

	const pageName = window.location.pathname;

	$(`a[href*='${pageName}#']`).on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop : $(this.hash).offset().top - 130
        }, 700);
    });
	if (window.location.hash) {
        var hash = window.location.hash;
        $('html, body').animate({
            scrollTop :  $(hash).offset().top - 130
        }, 500);
    };

})(jQuery);